<div
    [class]="'ap-notification ap-notification--' + status()"
    [ngClass]="{
        'ap-notification--last': last()
    }"
>
    <div class="ap-notification__container word-break">
        @if (showIcon()) {
            <div class="ap-notification__icon" aria-hidden="true">
                <ap-icon [manualSize]="20" [name]="getIconName()" data-testid="icon"></ap-icon>
            </div>
        }
        <div
            class="ap-notification__content-container"
            data-testid="content"
            [class.ap-notification__content-container--no-padding-right]="closeable()"
        >
            <ng-content></ng-content>
        </div>
        @if (closeable()) {
            <div class="ap-notification__close-action">
                <div class="ap-notification__close-action--hover-container">
                    <ap-action-icon (onClick)="emitClosed()" ariaLabel="Sluiten" data-testid="close-button">
                        <ap-icon name="close"></ap-icon>
                    </ap-action-icon>
                </div>
            </div>
        }
    </div>
</div>
